export default "__VITE_ASSET__CscT6uGw__"